var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm._f("formatPriceWithDecimals")(_vm.amount / _vm.conversionRate.exchange_rate * _vm.conversionRate.amount,_vm.conversionRate.currency_unit))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }